








import Vue from 'vue';

export default Vue.extend({

  name: 'DisplayMindMap',

  props: {
    height: { type: Number, default: 50 }
  }
});

